module.exports = __webpack_public_path__ + "img/1100.208bf999.svg";